import { http } from '@/core/helpers/http.helper';
import { GenerateResumeData } from './resume.interface';

export class PublicResumeService {
   async generateResume(generateResumeData: GenerateResumeData) {
      const response = await http.post<{ url: string }>(`/candidates/generate-resume`, generateResumeData);
      return response.data;
   }
}
